import React from "react";
import FeedActions from "./FeedActions";
import FeedMenuPopup from "./FeedMenuPopup";
import "./FeedCard.css";

function FeedCard({
  item,
  menuPost,
  setMenuPost,
  menuRef,
  setActivePost,
  setShowComments,
  onLike,
  onSave,
  onHide,
  onReport,
  isSaved,
  onConsult,
}) {
  const loggedInUser = JSON.parse(
  localStorage.getItem("civilink_user")
);

const user = item.user;

const isCurrentUser =
  loggedInUser?._id?.toString() ===
  user?._id?.toString();

const profilePhoto =
  user?.profilePhoto ||
  (isCurrentUser
    ? loggedInUser?.profilePhoto
    : null);

  const sharePostDirect = async () => {
    const postUrl = `${window.location.origin}/post/${item._id}`;

    try {
      if (navigator.share) {
        await navigator.share({
          title: "Civilink Post",
          url: postUrl,
        });
      } else {
        await navigator.clipboard.writeText(postUrl);
        alert("Post link copied");
      }
    } catch (err) {
      console.error("Share failed", err);
    }
  };

  const formatTime = (date) => {
    if (!date) return "Just now";

    const diff = Math.floor(
      (Date.now() - new Date(date)) / 1000
    );

    if (diff < 60) return "Just now";
    if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} hr ago`;
    if (diff < 604800) return `${Math.floor(diff / 86400)} day ago`;

    return new Date(date).toLocaleDateString();
  };

  return (
    <article className="feed-card">

      {/* HEADER */}
      <div className="feed-header">
        <div className="feed-user-box">
          <div className="feed-avatar">
            {profilePhoto ? (
  <img
    src={profilePhoto}
    alt={user?.name || "User"}
  />
) : (
  <span>
    {user?.name?.charAt(0)?.toUpperCase() || "C"}
  </span>
)}
          </div>

          <div className="feed-user-info">
            <div className="feed-user">
              <span className="feed-user-name">
                {user?.name || "Civilink User"}
              </span>

              <span className="feed-role">
                {user?.profession ||
  user?.role ||
  item.role ||
  "Member"}
              </span>
            </div>

            <div className="feed-meta">
              {item.location?.city}
              {item.location?.state
                ? `, ${item.location.state}`
                : ""}

              <span className="feed-meta-dot">•</span>

              <span>
                {formatTime(item.createdAt)}
              </span>
            </div>
          </div>
        </div>

        {/* MENU */}
        <button
          type="button"
          className="feed-menu"
          aria-label="Post options"
          onClick={(e) => {
            e.stopPropagation();

            setMenuPost(
              menuPost?._id === item._id
                ? null
                : item
            );
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* IMAGE */}
      {item.imageUrl && (
        <div className="feed-media">
          <img
            src={item.imageUrl}
            className="feed-image"
            alt="post"
          />
        </div>
      )}

      {/* CONTENT */}
      <div className="feed-content">

        {/* POST TYPE */}
        {item.type === "sell" && (
          <span className="badge sell">
            FOR SALE
          </span>
        )}

        {item.type === "rent" && (
          <span className="badge rent">
            FOR RENT
          </span>
        )}

        {item.title && (
          <h4 className="feed-title">
            {item.title}
          </h4>
        )}

        {item.text && (
          <p className="feed-text">
            {item.text}
          </p>
        )}

        {item.price && (
          <div className="feed-price">
            {typeof item.price === "object"
              ? `${item.price.amount ?? item.price.price ?? ""}`
              : item.price}
          </div>
        )}

      </div>

      {/* ACTIONS */}
      <FeedActions
        item={item}
        setActivePost={setActivePost}
        setShowComments={setShowComments}
        onShare={sharePostDirect}
        onLike={onLike}
        onConsult={onConsult}
      />

      {/* POPUP MENU */}
      {menuPost?._id === item._id && (
        <FeedMenuPopup
          post={item}
          menuRef={menuRef}
          onSave={onSave}
          onHide={onHide}
          onReport={onReport}
          close={() => setMenuPost(null)}
          isSaved={isSaved}
        />
      )}

    </article>
  );
}

export default FeedCard;